export function createChatSelectionTracker() {
    let activeToken = 0
    let profilesByToken = {}

    function beginSelection() {
        activeToken += 1
        profilesByToken[activeToken] = { male: null, female: null }
        return activeToken
    }

    function resolveProfile(token, role, profile) {
        if (token !== activeToken) {
            return { applied: false, ready: false, pair: null }
        }

        const currentPair = profilesByToken[token] || { male: null, female: null }
        currentPair[role] = profile
        profilesByToken[token] = currentPair

        const ready = Boolean(currentPair.male && currentPair.female)
        return {
            applied: true,
            ready,
            pair: ready ? { male: currentPair.male, female: currentPair.female } : null,
        }
    }

    return {
        beginSelection,
        resolveProfile,
        getActiveToken: () => activeToken,
    }
}
